import { render } from "./CompanyList.vue?vue&type=template&id=06ab39c7&scoped=true"
import script from "./CompanyList.vue?vue&type=script&lang=js"
export * from "./CompanyList.vue?vue&type=script&lang=js"

import "./CompanyList.vue?vue&type=style&index=0&id=06ab39c7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ab39c7"]])

export default __exports__